<template>
  <div class="stack-modal">
    <div v-if="videoUrl" class="trailer" :style="{ backgroundImage: `url(${videoImage().image})` }">
      <video 
        ref="previewVideo"
        autoplay
        loop
        playsinline
        webkit-playsinline
        preload="metadata"
        :poster="videoPoster"
        :src="videoUrl"
        >
      </video>
    
      <button class="control-btn" @click="sound()">
        <svg v-if="isMuted" width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.43175 0C9.0809 0 8.74872 0.140402 8.49865 0.390848L4.10936 4.85714H1.79155C0.802463 4.85714 0 5.67299 0 6.67857V10.3214C0 11.327 0.802463 12.1429 1.79155 12.1429H4.10936L8.50238 16.6092C8.74872 16.8596 9.08463 17 9.43548 17C10.1633 17 10.753 16.4004 10.753 15.6605V1.33951C10.7493 0.599554 10.1596 0 9.43175 0ZM5.11337 6.41295L8.95773 2.50446V14.4993L5.11337 10.5908C4.94541 10.4201 4.71774 10.3252 4.47887 10.3252H1.79155V6.68237H4.47887C4.71774 6.68237 4.94541 6.5875 5.11337 6.41674V6.41295ZM13.6979 5.42634C13.347 5.78304 13.347 6.35982 13.6979 6.71272L15.4521 8.49621L13.6979 10.2797C13.347 10.6364 13.347 11.2132 13.6979 11.5661C14.0487 11.919 14.616 11.9228 14.9631 11.5661L16.7174 9.78259L18.4716 11.5661C18.8224 11.9228 19.3898 11.9228 19.7369 11.5661C20.084 11.2094 20.0877 10.6326 19.7369 10.2797L17.9826 8.49621L19.7369 6.71272C20.0877 6.35603 20.0877 5.77924 19.7369 5.42634C19.386 5.07344 18.8187 5.06964 18.4716 5.42634L16.7174 7.20982L14.9631 5.42634C14.6123 5.06964 14.045 5.06964 13.6979 5.42634Z" fill="white"/>
        </svg>

         <svg v-else width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.37754 0C9.02871 0 8.69844 0.140402 8.44981 0.390848L4.08574 4.85714H1.78125C0.797852 4.85714 0 5.67299 0 6.67857V10.3214C0 11.327 0.797852 12.1429 1.78125 12.1429H4.08574L8.45352 16.6092C8.69844 16.8596 9.03242 17 9.38125 17C10.1049 17 10.6912 16.4004 10.6912 15.6605V1.33951C10.6875 0.599554 10.1012 0 9.37754 0ZM5.08398 6.41295L8.90625 2.50446V14.4993L5.08398 10.5908C4.91699 10.4201 4.69063 10.3252 4.45312 10.3252H1.78125V6.68237H4.45312C4.69063 6.68237 4.91699 6.5875 5.08398 6.41674V6.41295ZM16.3689 2.84598C15.9867 2.52723 15.4264 2.58795 15.1146 2.97879C14.8029 3.36964 14.8623 3.94263 15.2445 4.26138C16.4506 5.26317 17.2188 6.78862 17.2188 8.5C17.2188 10.2114 16.4506 11.7368 15.2445 12.7424C14.8623 13.0612 14.8066 13.6342 15.1146 14.025C15.4227 14.4158 15.9867 14.4728 16.3689 14.1578C17.9721 12.8221 19 10.7844 19 8.50379C19 6.22321 17.9721 4.18549 16.3689 2.84978V2.84598ZM14.1238 5.67299C13.7416 5.35424 13.1812 5.41496 12.8695 5.8058C12.5578 6.19665 12.6172 6.76964 12.9994 7.08839C13.4002 7.42232 13.6562 7.9308 13.6562 8.5C13.6562 9.0692 13.4002 9.57768 12.9994 9.9154C12.6172 10.2342 12.5615 10.8071 12.8695 11.198C13.1775 11.5888 13.7416 11.6458 14.1238 11.3308C14.9217 10.6592 15.4375 9.64219 15.4375 8.5C15.4375 7.35781 14.9217 6.34085 14.1201 5.67299H14.1238Z" fill="white"/>
        </svg>
      </button>
    </div>

    <div class="stack-content" :class="{'has-trailer' : videoUrl }">
      <div class="stack-column">
        <div class="stack-lead">
          <h1>{{ getTitle }}</h1>
          <div class="read-status">
            <Tracker class="tracker" :stats="stats" :showComplete="false" :showXp="false" />
            <span :class="{'read' : hasRead}">{{ hasRead ? 'Read' : 'Unread' }}</span>
          </div>
        </div>

        <!-- <div class="meta">
          <div class="meta-item">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.70312 3.20362L7.05234 2.93326C5.69434 2.37275 4.23672 2.08261 2.7625 2.08261H1.59375V13.6884H2.7625C4.44922 13.6884 6.12266 13.9851 7.70312 14.5588V3.20362ZM9.29688 14.5588C10.8773 13.9851 12.5508 13.6884 14.2375 13.6884H15.4062V2.08261H14.2375C12.7633 2.08261 11.3057 2.37275 9.94766 2.93326L9.29688 3.20362V14.5588ZM7.6666 1.47264L8.5 1.81884L9.3334 1.47264C10.8873 0.82971 12.5541 0.5 14.2375 0.5H15.4062C16.2861 0.5 17 1.20888 17 2.08261V13.6884C17 14.5621 16.2861 15.271 15.4062 15.271H14.2375C12.5541 15.271 10.8873 15.6007 9.3334 16.2437L8.9084 16.4184C8.64609 16.5272 8.35391 16.5272 8.0916 16.4184L7.6666 16.2437C6.1127 15.6007 4.4459 15.271 2.7625 15.271H1.59375C0.713867 15.271 0 14.5621 0 13.6884V2.08261C0 1.20888 0.713867 0.5 1.59375 0.5H2.7625C4.4459 0.5 6.1127 0.82971 7.6666 1.47264Z" fill="#6D7479"/>
            </svg>
            <span>{{ getReadTime }}</span>
          </div>
        </div> -->

        <p>{{ getSynopsis }}</p>

        <div v-if="isLocked && !canUnlock" class="actions">
          <button class="btn locked">
            <span>Locked</span>
            <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.58333 4.97059V7.20588H10.4167V4.97059C10.4167 3.42684 9.11146 2.17647 7.5 2.17647C5.88854 2.17647 4.58333 3.42684 4.58333 4.97059ZM2.83333 7.20588V4.97059C2.83333 2.50129 4.9224 0.5 7.5 0.5C10.0776 0.5 12.1667 2.50129 12.1667 4.97059V7.20588C13.4536 7.20588 14.5 8.20827 14.5 9.44118V17.2647C14.5 18.4976 13.4536 19.5 12.1667 19.5H2.83333C1.54635 19.5 0.5 18.4976 0.5 17.2647V9.44118C0.5 8.20827 1.54635 7.20588 2.83333 7.20588ZM10.4167 8.88235H4.58333H2.83333C2.5125 8.88235 2.25 9.13382 2.25 9.44118V17.2647C2.25 17.5721 2.5125 17.8235 2.83333 17.8235H12.1667C12.4875 17.8235 12.75 17.5721 12.75 17.2647V9.44118C12.75 9.13382 12.4875 8.88235 12.1667 8.88235H10.4167Z" fill="#011D01"/>
            </svg>
          </button>
        </div>

        <div v-else-if="isLocked && canUnlock" class="actions">
          <button class="btn unlock" @click="unlock()">
            <span>Unlock {{ getTitle }}?</span>
            <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.08333 4.97059C4.08333 3.42684 5.38854 2.17647 7 2.17647C8.5349 2.17647 9.79271 3.31158 9.90937 4.75404C9.94583 5.21507 10.3687 5.56085 10.85 5.52592C11.3313 5.49099 11.6922 5.08585 11.6557 4.62482C11.4661 2.31618 9.45729 0.5 7 0.5C4.4224 0.5 2.33333 2.50129 2.33333 4.97059V7.20588C1.04635 7.20588 0 8.20827 0 9.44118V17.2647C0 18.4976 1.04635 19.5 2.33333 19.5H11.6667C12.9536 19.5 14 18.4976 14 17.2647V9.44118C14 8.20827 12.9536 7.20588 11.6667 7.20588H4.08333V4.97059ZM2.33333 8.88235H4.08333H11.6667C11.9875 8.88235 12.25 9.13382 12.25 9.44118V17.2647C12.25 17.5721 11.9875 17.8235 11.6667 17.8235H2.33333C2.0125 17.8235 1.75 17.5721 1.75 17.2647V9.44118C1.75 9.13382 2.0125 8.88235 2.33333 8.88235Z" fill="#011D01"/>
            </svg>
          </button>
        </div>

        <div v-else class="actions">
          <button v-if="hasVideo" class="btn watch" @click="watch()">
            <span>Watch</span>
            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.25385 0.712748C0.788462 0.985954 0.5 1.48304 0.5 2.01807V15.9819C0.5 16.517 0.788462 17.014 1.25385 17.2873C1.71923 17.5605 2.3 17.5718 2.77692 17.3138L15.7 10.3319C16.1923 10.0663 16.5 9.554 16.5 9C16.5 8.446 16.1923 7.93374 15.7 7.66812L2.77692 0.686186C2.3 0.428158 1.72308 0.439542 1.25385 0.712748ZM2.34615 15.4697V2.53033L14.3192 9L2.34615 15.4697Z" fill="black"/>
            </svg>
          </button>
          <button class="btn" @click="read()">
            <span>Read</span>
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.20312 2.70362L7.55234 2.43326C6.19434 1.87275 4.73672 1.58261 3.2625 1.58261H2.09375V13.1884H3.2625C4.94922 13.1884 6.62266 13.4851 8.20312 14.0588V2.70362ZM9.79688 14.0588C11.3773 13.4851 13.0508 13.1884 14.7375 13.1884H15.9062V1.58261H14.7375C13.2633 1.58261 11.8057 1.87275 10.4477 2.43326L9.79688 2.70362V14.0588ZM8.1666 0.972644L9 1.31884L9.8334 0.972644C11.3873 0.32971 13.0541 0 14.7375 0H15.9062C16.7861 0 17.5 0.708876 17.5 1.58261V13.1884C17.5 14.0621 16.7861 14.771 15.9062 14.771H14.7375C13.0541 14.771 11.3873 15.1007 9.8334 15.7437L9.4084 15.9184C9.14609 16.0272 8.85391 16.0272 8.5916 15.9184L8.1666 15.7437C6.6127 15.1007 4.9459 14.771 3.2625 14.771H2.09375C1.21387 14.771 0.5 14.0621 0.5 13.1884V1.58261C0.5 0.708876 1.21387 0 2.09375 0H3.2625C4.9459 0 6.6127 0.32971 8.1666 0.972644Z" fill="black"/>
            </svg>
          </button>
        </div>

        <div v-if="isLocked && !canUnlock" class="unlock-actions">
          <p>You've got {{ this.isInDetox ? 'three' : 'two' }} easy ways to unlock this channel and start reading.</p>

          <div class="unlock-options">
            <div class="unlock-option" @click="routeTo('invite')" v-if="ifHasUnlockSlots">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.9453 5.13297L15.8985 4.80094C15.8008 4.11344 15.2617 3.57437 14.5742 3.47672L14.2422 3.42984C13.7305 3.35562 13.375 2.88297 13.4453 2.36734C13.5157 1.85172 13.9922 1.50016 14.5078 1.57047L14.8399 1.61734C16.3516 1.83219 17.5391 3.02359 17.7578 4.53531L17.8047 4.86734C17.8789 5.37906 17.5235 5.85562 17.0078 5.92984C16.4922 6.00406 16.0196 5.64859 15.9453 5.13297ZM5.62503 5.18375C6.32425 4.48453 7.33597 4.28531 8.21097 4.59C8.33206 4.32437 8.50003 4.07828 8.71878 3.85953C9.69534 2.88297 11.2774 2.88297 12.2539 3.85953L16.875 8.47672V8.2775C16.875 6.89859 17.9961 5.7775 19.375 5.7775C20.7539 5.7775 21.875 6.89859 21.875 8.2775V14.4377C21.875 14.5002 21.875 14.5587 21.8711 14.6212C21.8711 14.6447 21.875 14.6642 21.875 14.6877C21.875 18.9806 18.4102 22.4689 14.1211 22.5002H14.1016H13.8047C11.7344 22.5002 9.74612 21.6759 8.28128 20.2111L3.8555 15.7892C2.87894 14.8127 2.87894 13.2306 3.8555 12.2541C4.00784 12.1017 4.17581 11.9728 4.35159 11.8673L4.29691 11.8127C3.32034 10.8361 3.32034 9.25406 4.29691 8.2775C4.51566 8.05875 4.76175 7.89078 5.02737 7.76969C4.72659 6.89469 4.92191 5.88297 5.62112 5.18375H5.62503ZM8.72269 7.39859L8.71878 7.39469L7.83597 6.51187C7.59378 6.26969 7.19534 6.26969 6.95316 6.51187C6.71097 6.75406 6.71097 7.1525 6.95316 7.39469L7.83206 8.27359L7.83597 8.2775L11.5938 12.0353C11.961 12.4025 11.961 12.9962 11.5938 13.3595C11.2266 13.7228 10.6328 13.7267 10.2696 13.3595L6.51566 9.60562L6.51175 9.60172C6.26956 9.35953 5.87112 9.35953 5.62894 9.60172C5.38675 9.84391 5.38675 10.2423 5.62894 10.4845L7.17191 12.0275L7.17581 12.0314L9.38675 14.2423C9.75394 14.6095 9.75394 15.2033 9.38675 15.5666C9.01956 15.9298 8.42581 15.9337 8.06253 15.5666L6.07816 13.5822L6.07425 13.5783C5.83206 13.3361 5.43362 13.3361 5.19144 13.5783C4.94925 13.8205 4.94925 14.2189 5.19144 14.4611L9.6055 18.8869C10.7188 20.0002 12.2305 20.6252 13.8047 20.6252H14.0977C17.3321 20.6056 19.9532 18.0041 20 14.7736C19.9961 14.7345 19.9961 14.6916 19.9961 14.6525C20 14.5822 20 14.5119 20 14.4377V8.2775C20 7.93375 19.7188 7.6525 19.375 7.6525C19.0313 7.6525 18.75 7.93375 18.75 8.2775V10.7423C18.75 11.1212 18.5235 11.465 18.1719 11.6095C17.8203 11.7541 17.418 11.6759 17.1485 11.4064L10.9297 5.18375C10.6875 4.94156 10.2891 4.94156 10.0469 5.18375C9.80472 5.42594 9.80472 5.82047 10.043 6.06656L13.8008 9.82437C14.168 10.1916 14.168 10.7853 13.8008 11.1486C13.4336 11.5119 12.8399 11.5158 12.4766 11.1486L8.72269 7.39469V7.39859ZM2.36722 17.1955C2.87894 17.1212 3.3555 17.4767 3.42972 17.9923L3.47659 18.3244C3.57425 19.0119 4.11331 19.5509 4.80081 19.6486L5.13284 19.6955C5.64456 19.7697 6.00003 20.2423 5.92972 20.758C5.85941 21.2736 5.38284 21.6252 4.86722 21.5548L4.53519 21.508C3.02347 21.2892 1.83597 20.1017 1.62112 18.59L1.57425 18.258C1.50003 17.7462 1.8555 17.2697 2.37112 17.1955H2.36722Z" fill="#FFDE00"/>
              </svg>

              <div class="unlock-content">
                <h3>Invite your friends</h3>
                <p>Unlock 5 channels for free;<br>Invite your friends.</p>
              </div>

              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7812 11.0313C18.075 10.7376 18.075 10.2626 17.7812 9.97197L12.5312 4.71885C12.2375 4.4251 11.7625 4.4251 11.4719 4.71885C11.1813 5.0126 11.1781 5.4876 11.4719 5.77822L15.4406 9.74697H2.75C2.33437 9.74697 2 10.0813 2 10.497C2 10.9126 2.33437 11.247 2.75 11.247H15.4406L11.4719 15.2157C11.1781 15.5095 11.1781 15.9845 11.4719 16.2751C11.7656 16.5657 12.2406 16.5688 12.5312 16.2751L17.7812 11.0313Z" fill="#FFDE00"/>
              </svg>
            </div>

            <div class="unlock-option" @click="routeTo('read')" v-if="isInDetox">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.5625 6.95312L10.7969 6.63281C9.19922 5.96875 7.48437 5.625 5.75 5.625H4.375V19.375H5.75C7.73437 19.375 9.70312 19.7266 11.5625 20.4062V6.95312ZM13.4375 20.4062C15.2969 19.7266 17.2656 19.375 19.25 19.375H20.625V5.625H19.25C17.5156 5.625 15.8008 5.96875 14.2031 6.63281L13.4375 6.95312V20.4062ZM11.5195 4.90234L12.5 5.3125L13.4805 4.90234C15.3086 4.14062 17.2695 3.75 19.25 3.75H20.625C21.6602 3.75 22.5 4.58984 22.5 5.625V19.375C22.5 20.4102 21.6602 21.25 20.625 21.25H19.25C17.2695 21.25 15.3086 21.6406 13.4805 22.4023L12.9805 22.6094C12.6719 22.7383 12.3281 22.7383 12.0195 22.6094L11.5195 22.4023C9.69141 21.6406 7.73047 21.25 5.75 21.25H4.375C3.33984 21.25 2.5 20.4102 2.5 19.375V5.625C2.5 4.58984 3.33984 3.75 4.375 3.75H5.75C7.73047 3.75 9.69141 4.14062 11.5195 4.90234Z" fill="#FFDE00"/>
              </svg>

              <div class="unlock-content">
                <h3>Complete your detox</h3>
                <p>Unlock 3 channels for free;<br>Just read each day.</p>
              </div>

              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7812 11.0313C18.075 10.7376 18.075 10.2626 17.7812 9.97197L12.5312 4.71885C12.2375 4.4251 11.7625 4.4251 11.4719 4.71885C11.1813 5.0126 11.1781 5.4876 11.4719 5.77822L15.4406 9.74697H2.75C2.33437 9.74697 2 10.0813 2 10.497C2 10.9126 2.33437 11.247 2.75 11.247H15.4406L11.4719 15.2157C11.1781 15.5095 11.1781 15.9845 11.4719 16.2751C11.7656 16.5657 12.2406 16.5688 12.5312 16.2751L17.7812 11.0313Z" fill="#FFDE00"/>
              </svg>
            </div>

            <div class="unlock-option pro" @click="goPro()">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.34362 5.00787L6.26549 10.8516C5.47643 12.0391 5.01549 13.4688 5.01549 15.0001C5.01549 19.1407 8.37487 22.5001 12.5155 22.5001C16.6561 22.5001 20.0155 19.1407 20.0155 15.0001C20.0155 13.4649 19.5546 12.0391 18.7655 10.8516L21.6796 5.00787C22.1444 4.08209 21.7655 2.95709 20.8397 2.49224L17.4921 0.816462C16.5897 0.363337 15.4921 0.710993 15.0077 1.59381L12.5155 6.16412L10.0233 1.59381C9.53503 0.710993 8.43737 0.363337 7.53502 0.816462L4.17956 2.49224C3.25377 2.95709 2.87877 4.08209 3.34362 5.00787ZM13.8553 7.62115L16.6522 2.49224L20.0038 4.16802L17.4217 9.33209C16.4256 8.46881 15.203 7.86334 13.8553 7.62115ZM11.1678 7.62115C9.82018 7.86334 8.59362 8.46881 7.60143 9.33209L5.0194 4.16802L8.37096 2.49224L11.1678 7.62115ZM6.88659 15.0001C6.88659 11.8946 9.40612 9.37506 12.5116 9.37506C15.6171 9.37506 18.1366 11.8946 18.1366 15.0001C18.1366 18.1055 15.6171 20.6251 12.5116 20.6251C9.40612 20.6251 6.88659 18.1055 6.88659 15.0001ZM13.7147 13.0665L12.8397 11.293C12.7069 11.0196 12.3202 11.0196 12.1835 11.293L11.3085 13.0665C11.2538 13.1758 11.1522 13.2501 11.035 13.2657L9.07799 13.5508C8.77721 13.5938 8.66002 13.961 8.87487 14.1758L10.2928 15.5586C10.3788 15.6407 10.4178 15.7618 10.3983 15.8829L10.0624 17.8321C10.0116 18.129 10.3241 18.3594 10.5936 18.2188L12.3436 17.293C12.4491 17.2383 12.578 17.2383 12.6835 17.293L14.4335 18.2149C14.703 18.3555 15.0155 18.129 14.9647 17.8282L14.6288 15.879C14.6092 15.7618 14.6483 15.6407 14.7342 15.5547L16.1522 14.1719C16.3671 13.961 16.2499 13.5938 15.9491 13.5469L13.9921 13.2618C13.8749 13.2461 13.7694 13.168 13.7186 13.0626L13.7147 13.0665Z" fill="#14B31F"/>
              </svg>

              <div class="unlock-content">
                <h3>Go Pro</h3>
                <p>Support a tiny team + unlock every channel.</p>
              </div>

              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7812 11.0313C18.075 10.7376 18.075 10.2626 17.7812 9.97197L12.5312 4.71885C12.2375 4.4251 11.7625 4.4251 11.4719 4.71885C11.1813 5.0126 11.1781 5.4876 11.4719 5.77822L15.4406 9.74697H2.75C2.33437 9.74697 2 10.0813 2 10.497C2 10.9126 2.33437 11.247 2.75 11.247H15.4406L11.4719 15.2157C11.1781 15.5095 11.1781 15.9845 11.4719 16.2751C11.7656 16.5657 12.2406 16.5688 12.5312 16.2751L17.7812 11.0313Z" fill="#FFDE00"/>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div class="stack-column">
        <div class="other-actions">
          <div class="action-item" @click="like()">
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.65119 1.61647C8.51749 0.16678 10.3584 -0.416428 11.9202 0.316747L12.2201 0.475047C13.6695 1.34569 14.2526 3.18696 13.5196 4.74912L12.9323 5.99886H17.5012L17.8095 6.01552C19.3213 6.16965 20.5 7.44854 20.5 8.99821C20.5 9.54809 20.3501 10.0563 20.0918 10.4979C20.3459 10.9395 20.4958 11.4477 20.5 11.9976C20.5 12.7599 20.2126 13.4472 19.7503 13.9763C19.8045 14.1971 19.8336 14.4262 19.8336 14.6637C19.8336 15.7093 19.2963 16.6216 18.4925 17.1589C18.4134 18.6378 17.268 19.8334 15.8103 19.9792L15.5021 19.9958H11.1664C10.4167 19.9958 9.67118 19.8542 8.97563 19.5834L8.67992 19.4585L8.65077 19.446L8.37588 19.3126L8.34673 19.3001L7.83861 19.0294C7.32632 18.7586 6.86818 18.417 6.46835 18.0254C6.29758 19.146 5.33132 20 4.16514 20H2.83236C1.5454 20 0.5 18.9544 0.5 17.6672L0.50833 8.33169C0.50833 7.04446 1.55373 5.99886 2.84069 5.99886H4.17347C4.62328 5.99886 5.04394 6.12799 5.40212 6.35295L7.48875 1.9164L7.51374 1.86641L7.6262 1.65812L7.65119 1.62063V1.61647ZM2.84069 7.99842C2.65743 7.99842 2.5075 8.14839 2.5075 8.33169V17.663C2.5075 17.8463 2.65743 17.9963 2.84069 17.9963H4.17347C4.35673 17.9963 4.50666 17.8463 4.50666 17.663V8.33169C4.50666 8.14839 4.35673 7.99842 4.17347 7.99842H2.84069ZM11.0706 2.12469C10.4542 1.83725 9.72532 2.05804 9.37547 2.62458L9.28384 2.79121L6.91816 7.82763C6.77239 8.14006 6.68909 8.47332 6.66826 8.81491L6.6641 8.98988V13.693L6.67243 14.0221C6.77239 15.3843 7.56372 16.6091 8.78405 17.2589L9.26302 17.513L9.52541 17.6422C10.0419 17.8755 10.6 17.9963 11.1664 17.9963H15.5021L15.602 17.9921C16.106 17.9421 16.5017 17.513 16.5017 16.9965L16.4933 16.8882C16.4892 16.8507 16.485 16.8174 16.4767 16.7799C16.3642 16.2758 16.6558 15.7717 17.1431 15.6134C17.5471 15.4843 17.8344 15.1052 17.8344 14.6637C17.8344 14.4845 17.7886 14.3221 17.7053 14.1721C17.4429 13.7097 17.5887 13.1223 18.0385 12.839C18.3217 12.6599 18.505 12.3475 18.505 11.9976C18.505 11.7018 18.3759 11.4352 18.1635 11.2477C17.9469 11.0561 17.8219 10.7853 17.8219 10.4979C17.8219 10.2104 17.9469 9.93967 18.1635 9.74805C18.3759 9.56059 18.505 9.29398 18.505 8.99821L18.5008 8.89823C18.455 8.4275 18.0802 8.05258 17.6095 8.00676L17.5096 8.00259H11.3663C11.0248 8.00259 10.7082 7.82763 10.525 7.54019C10.3417 7.25275 10.3167 6.88616 10.4625 6.5779L11.712 3.89931C12.0035 3.27444 11.7703 2.5371 11.1914 2.19134L11.0706 2.12469Z" fill="#6D7479"/>
            </svg>
            <span>Like</span>
          </div>

          <div class="action-item" @click="share()">
            <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.0136 6.89592C14.6109 6.89592 15.0915 6.4347 15.0915 5.86139V3.04229L20.5443 8.2753L15.0915 13.5083V10.6892C15.0915 10.1159 14.6109 9.65468 14.0136 9.65468H8.62374C5.65034 9.65468 3.14407 11.5815 2.38949 14.2023C2.24127 13.6678 2.15593 13.0729 2.15593 12.4134C2.15593 9.36587 4.72958 6.89592 7.90509 6.89592H14.0136ZM12.9356 11.7237V15.1722C12.9356 15.7282 13.2859 16.2326 13.8249 16.4481C14.3639 16.6636 14.9793 16.5429 15.3925 16.1507L22.5789 9.2538C23.1404 8.71498 23.1404 7.83993 22.5789 7.30112L15.3925 0.404234C14.9793 0.00766326 14.3639 -0.108722 13.8249 0.106806C13.2859 0.322333 12.9356 0.822357 12.9356 1.37842V4.82686H7.90509C3.53933 4.82686 0 8.22357 0 12.4134C0 15.7757 1.73373 17.8533 3.08568 18.9698C3.26983 19.1206 3.44949 19.2543 3.61119 19.3707C3.75492 19.4741 3.88966 19.5603 4.01094 19.6379C4.21306 19.7672 4.38373 19.8578 4.49602 19.9181C4.60831 19.9784 4.73407 20 4.85983 20C5.34941 20 5.74467 19.6164 5.74467 19.1508C5.74467 18.8577 5.58297 18.5818 5.37187 18.3706C5.34941 18.3491 5.33145 18.3318 5.30899 18.3103C5.20119 18.2111 5.07992 18.0904 4.96314 17.9396C4.88678 17.8404 4.81043 17.724 4.73856 17.599C4.50051 17.1809 4.31187 16.6119 4.31187 15.8662C4.31187 13.5816 6.24323 11.7281 8.62374 11.7281H12.9356V11.7237Z" fill="#6D7479"/>
            </svg>
            <span>Share</span>
          </div>
        </div>

        <div class="dashboard-group">
          <UserTrack v-if="achievement.locales || achievement.topics || achievement.time" :size="120" :progress="progress" />

          <div class="dashboard">
            <div class="dashboard-item" :class="{'time' : isUnlocked('time')}">
              <base-svg svg="onboarding-clock" width="1.5rem" />
              <span v-if="!isUnlocked('time')">Locked</span>
              <span v-else-if="achievement.time">{{ achievement.time }} {{ achievement.time | plural('minute') }}</span>
              <span v-else>{{ prediction.time }} {{ prediction.time | plural('minute') }}</span>
            </div>
            
            <div class="dashboard-item" :class="{'topics' : isUnlocked('topics')}">
              <base-svg svg="onboarding-book" width="1.5rem" />
              <span v-if="!isUnlocked('topics')">Locked</span>
              <span v-else-if="achievement.topics">{{ achievement.topics }} {{ achievement.topics | plural('topic') }}</span>
              <span v-else>{{ prediction.topics }} {{ prediction.topics | plural('topic') }}</span>
            </div>

            <div class="dashboard-item" :class="{'countries' : isUnlocked('locales')}">
              <base-svg svg="onboarding-globe" width="1.5rem" />
              <span v-if="!isUnlocked('locales')">Locked</span>
              <span v-else-if="achievement.locales">{{ achievement.locales }} {{ achievement.locales | plural('country') }}</span>
              <span v-else>{{ prediction.locales }} {{ prediction.locales | plural('country') }}</span>
            </div>

            <Lottie ref="lottie" animation="confetti-jump" />
          </div>
        </div>

        <div class="streaks">
          <div class="streak-item xp" v-if="getXp">
            <base-svg svg="sparkles" height="1.5rem" />
            <span>+{{ getXp }} daily XP</span>
          </div>

          <div class="streak-item streak" :class="{'achieved' : hasRead}">
            <svg width="511" height="513" viewBox="0 0 511 513" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M216 309.7C188.4 279.4 150.5 208.7 144.2 48H366.4C360 208.7 322.1 279.4 294.6 309.7C280.9 324.8 268.7 331.1 261.5 333.8C258.9 334.8 256.8 335.3 255.4 335.7C254 335.4 251.9 334.8 249.3 333.8C242.1 331.1 229.9 324.8 216.2 309.7H216ZM367.3 0H143.3C116.8 0 95.2 21.8 96.2 48.2C96.4 53.5 96.6 58.8 96.9 64H47.3C21.2 64 -1.80003 85.5 0.0999672 113.7C4.89997 184.2 29.5 233.9 63.1 268.1C95.5 301 134.6 318 167.9 326.7C190.7 357.7 214.3 371.9 231.2 378.5V464.1H151.2C137.9 464.1 127.2 474.8 127.2 488.1C127.2 501.4 137.9 512.1 151.2 512.1H359.2C372.5 512.1 383.2 501.4 383.2 488.1C383.2 474.8 372.5 464.1 359.2 464.1H279.2V378.5C296.7 371.7 321.5 356.6 345.1 323.2C379.1 313.2 417.5 295.1 448.9 262.7C481.7 228.8 505.5 180.7 510.4 113.8C512.4 85.5 489.3 64.1 463.3 64.1H413.7C414 58.9 414.2 53.7 414.4 48.3C415.4 21.8 393.8 0.0999985 367.3 0.0999985V0ZM410 112H462.3C457.9 167.5 438.5 204.3 414.4 229.2C403.6 240.3 391.6 249.4 379 256.8C392.6 220.1 403.8 172.9 410 112ZM133.3 261.6C120.7 254.5 108.4 245.6 97.4 234.4C72.8 209.4 52.5 171.4 48.2 112H100.6C107.1 175.6 118.9 224.3 133.4 261.6H133.3Z" fill="black"/>
            </svg>
            <span>{{ getStreak }} day streak</span>
          </div>
        </div>

        <p class="publishers" v-if="getPublishers">Sources: {{ getPublishers }}</p>
      </div>

      <div class="deep-dive" v-if="getStories.length > 0 && hasRead">
        <h2>Read the full story</h2>
        <p v-if="isLocked && !canUnlock">
          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 2.25C9.57857 2.25 10.8571 3.50859 10.8571 5.0625V6.75H5.14286V5.0625C5.14286 3.50859 6.42143 2.25 8 2.25ZM2.85714 5.0625V6.75H2.28571C1.025 6.75 0 7.75898 0 9V15.75C0 16.991 1.025 18 2.28571 18H13.7143C14.975 18 16 16.991 16 15.75V9C16 7.75898 14.975 6.75 13.7143 6.75H13.1429V5.0625C13.1429 2.26758 10.8393 0 8 0C5.16071 0 2.85714 2.26758 2.85714 5.0625ZM9.14286 11.25V13.5C9.14286 14.1223 8.63214 14.625 8 14.625C7.36786 14.625 6.85714 14.1223 6.85714 13.5V11.25C6.85714 10.6277 7.36786 10.125 8 10.125C8.63214 10.125 9.14286 10.6277 9.14286 11.25Z" fill="black"/>
          </svg>
          Unlock this channel to catch the full story
        </p>

        <div class="stories" :class="{'locked' : isLocked}">
          <div v-for="story in getStories" :key="story.slug" class="story" @click.stop="readStory('story', story)">
            <div v-if="story.image" class="story-image">
              <div onerror="this.style.display='none'" class="inner-image">
                <img :src="story.image" :alt="story.name" />
              </div>
            </div>

            <div class="story-content-wrapper">
              <div>
                <div class="story-content">
                  <h4 v-if="story.name" class="story-name">{{ story.name }}</h4>
                  <div class="story-meta-wrapper">
                    <span class="story-meta">
                      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.5938 7.5C13.5937 9.11616 12.9517 10.6661 11.8089 11.8089C10.6661 12.9517 9.11616 13.5938 7.5 13.5938C5.88384 13.5938 4.33387 12.9517 3.19107 11.8089C2.04827 10.6661 1.40625 9.11616 1.40625 7.5C1.40625 5.88384 2.04827 4.33387 3.19107 3.19107C4.33387 2.04827 5.88384 1.40625 7.5 1.40625C9.11616 1.40625 10.6661 2.04827 11.8089 3.19107C12.9517 4.33387 13.5937 5.88384 13.5938 7.5ZM0 7.5C0 9.48912 0.790176 11.3968 2.1967 12.8033C3.60322 14.2098 5.51088 15 7.5 15C9.48912 15 11.3968 14.2098 12.8033 12.8033C14.2098 11.3968 15 9.48912 15 7.5C15 5.51088 14.2098 3.60322 12.8033 2.1967C11.3968 0.790176 9.48912 0 7.5 0C5.51088 0 3.60322 0.790176 2.1967 2.1967C0.790176 3.60322 0 5.51088 0 7.5ZM6.79688 3.51562V7.5C6.79688 7.73438 6.91406 7.9541 7.11035 8.08594L9.92285 9.96094C10.2451 10.1777 10.6816 10.0898 10.8984 9.76465C11.1152 9.43945 11.0273 9.00586 10.7021 8.78906L8.20312 7.125V3.51562C8.20312 3.12598 7.88965 2.8125 7.5 2.8125C7.11035 2.8125 6.79688 3.12598 6.79688 3.51562Z" fill="black"/>
                      </svg>
                      {{ story.last_published_at | ago }}
                    </span>
                    <span class="story-meta">{{ story.meta.cx_pub }} sources</span>
                    <div class="item-mood" :class="getMood(story.mood.avg).code">
                      <div class="item-mood-marker"></div>
                      <span>{{ getMood(story.mood.avg).name }}</span>
                    </div>
                  </div>
                  <span v-if="story.stack" class="story-stack">{{ story.stack }}</span>
                  <span v-if="story.synopsis" class="story-stack">{{ story.synopsis }}</span>
                </div>
              </div>

              <ul class="meta" :title="story.last_published | date">
                <li v-for="(topic, idx) in story.topics.slice(0, 3)" :key="`story-${idx}-${story.slug}-topic-${topic.topic_code}`">
                  <router-link :to="`/topic/${topic.topic_code}`">
                    {{ topic.topic_name }}
                  </router-link>
                </li>
              </ul> 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import API from 'app/axios';
  import Tracker from '@/components/v5/stacks/Tracker.vue';
  import UserTrack from '@/components/v5/elements/UserTrack.vue';
  import Lottie from '@/components/v5/Lottie.vue';

  export default {
    data() {
      return {
        stats: {},
        oRandImage: {
          image: 'https://nourished.news/r/x/pix.gif',
        },
        isMuted: true,
        progress: {
          time: 0,
          topics: 0,
          locales: 0
        },
        achievement: {
          time: null,
          topics: null,
          locales: null,
        },
        timing: {
          steps: 150,
        },
      }
    },

    props: {
      slide: {
        type: Object
      },
    },

    mounted () {
      this.fetchStack();

      if (this.$refs.previewVideo) {
        // this.$refs.previewVideo.muted = this.muted;
        // this.isMuted = this.muted;
        this.$refs.previewVideo.muted = true;
        this.isMuted = true;
      }

      this.EventBus.$on('tab:update', (payload) => {
        this.stats = payload.stats
      })

      this.EventBus.$on('stack:close', () => {
        setTimeout(() => {
          this.animateDashboard();
        }, 1000);
      })

      this.EventBus.$on('full:video:close', () => {
        this.resumeVideo();
      })
    },

    components: {
      Tracker,
      UserTrack,
      Lottie,
    },

    computed: {
      getAccount() {
        return this.$store.getters.getAccount;
      },

      isAlpha() {
        return this.$store.getters.isAlpha;
      },

      hasApp() {
        return this.$store.getters.hasApp;
      },

      isGeo() {
        return this.stack?.meta?.type === 'geo';
      },

      muted() {
        return this.$userEngine.getPref('layout.media.mute');
      },

      stackSlug() {
        return this.$route?.params?.slug; 
      },

      stack() {
        return this.$store.getters.getStack(this.stackSlug);
      },

      getXp() {
        return this.stack?.shelf?.xp || null;
      },

      getStreak() {
        return this.stack?.shelf?.stats?.streak || 0;
      },

      isDesktop() {
        return this.$layoutEngine.isDesktop;
      },

      isInDetox() {
        return this.$coachingEngine.isInDetox;
      },

      ifHasUnlockSlots () {
        return this.$userEngine.hasInviteSlots;
      },

      videoUrl() {
        let video = this.stack?.shelf?.vfx?.preview;
        return video ? video : null;
      },

      videoPoster() {
        let video = this.stack?.meta?.vfx?.thumbs?.wide;
        return video ? video : "https://nourished.news/r/x/pix.gif";
      },

      hasVideo() {
        const size = this.isDesktop ? 'long-wide' : 'long-tall';
        let video = this.stack?.shelf?.vfx[size];
        if (video) {
          return true;
        }
        return false;
      },

      hasRead() {
        if (this.stats?.read && (this.stats?.read === this.stats?.cards)) {
          return true;
        }
        return false;
      },

      getTitle() {
        return this.stack?.meta?.name ? `${this.stack?.shelf?.emoji || ''} ${this.stack?.meta?.name}` : `…`;
      },

      getSynopsis () {
        return this.stack.meta?.edition?.synopsis || '…';
      },

      getStories() {
        return this.stack?.stories;
      },

      isLocked() {
        return !(this.stack?.shelf?.locked === false);
      },

      canUnlock() {
        return this.getAccount?.system?.unlocks > 0;
      },

      isPro() {
        return this.$store.getters.isPro;
      },

      prediction() {
        const iMinSalienceTopic = .1;
        const iMinSalienceLocale = .45;
        let oTopics = {};
        let oLocales = {};

        this.stack.structure
         ?.filter((card) => card.dot)
          .forEach((card) => {
            // topics.. 
            card.meta?.topics.forEach(topic => {
              if (topic.salience.avg < iMinSalienceTopic) {
                return;
              }
              oTopics[topic.topic_code] = true;
            });
            // locales..
            card.meta?.locales.forEach(locale => {
              if (locale.salience < iMinSalienceLocale) {
                return;
              }
              oLocales[locale.iso] = true;
            })
          });
        

        return {
          time: Math.round(this.getReadTimeSecs / 60),
          topics: Object.keys(oTopics).length,
          locales: Object.keys(oLocales).length,
        }
      },

      getReadTimeSecs() {
        if (!this.stack.structure?.length) {
          return '…';
        }

        const cards = this.stack.structure?.filter((card) => card.dot);
        const avgReadingTime = 35;
        const totalReadingTime = cards.length * avgReadingTime

        const randomNumbers = [0, 5];
        const randomValue = randomNumbers[Math.floor(Math.random() * randomNumbers.length)];

        const adjustedReadingTime = Math.random() > 0.5
          ? totalReadingTime + randomValue
          : totalReadingTime - randomValue;

        return adjustedReadingTime;
      },

      getReadTime() {
        const adjustedReadingTime = this.getReadTimeSecs;
        const mins = Math.floor(adjustedReadingTime / 60);
        const secs = adjustedReadingTime % 60;

        if (mins > 0 && secs === 0) return `${mins} min`;
        let result = '';
        if (mins > 0) result += `${mins} min`;
        if (secs > 0) result += (mins > 0 ? ' ' : '') + `${secs} secs`;
        if (!result) result = 'Short read';
        return result;
      },

      aPublishers() {
        let aPubs = [];
        this.stack?.stories?.map((story) => {
          story?.articles?.map((article) => article?.publisher).forEach(oPub => {
            let iPub = aPubs.findIndex(a => a.code == oPub.code);
            if (iPub != -1) {
              aPubs[iPub].cx++;
              return;
            }
            aPubs.push({
              ...oPub,
              ...{
                cx: 1,
              }
            });
          });
        });
        
        aPubs.sort((a, b) => {
          return a.cx >= b.cx ? -1 : 1;
        });

        return aPubs.map((a) => {
          return a?.name
        });
      },

      getPublishers() {
        const show = 5;
        let string = this.aPublishers.slice(0,show).join(', ');
        if (this.aPublishers.length - show > 0) {
          string += ` and ${this.aPublishers.length - show} more`
        }
        return string;
      },

      summaryItems() {
        const tracks = this.$userEngine.dialTracks || {};

        if (!this.focus) {
          return tracks;
        }

        const item = Object.values(tracks).find(track => track.slug === this.focus);
        return item ? [item] : [];
      },

      dialData() {
        return this.$store.getters.getLibraryItem('dial') || {};
      },

      dialDiff() {
        return this.$userEngine.dialDiff;
      }
    },

    methods: {
      async fetchStack() {
        await API.getStack(this.stackSlug);
      },

      isUnlocked (slug) {
        return this.$userEngine.dialTrackUnlocked(slug);
      },

      readStory(sMode, story) {
        if (sMode != 'story') {
          // console.warn(`GoDeeper [${sMode}] - Not yet implemented...`);
          return;
        }

        let sSlug = story.slug;
        let sNode = story?.clusters?.timeseries?.[0]?.links?.[0];
        // console.warn(`GoDeeper [${sMode}] + [${sSlug}] -- Node = ${sNode}`);

        if (!sNode) {
          // console.warn(`GoDeeper [${sMode}] - Weird? No node?...`);
          return;
        }

        // not sure we need this -- but since there's no nav yet, probably our responsibility
        API.getStoryV3(sSlug);
        API.getStoryNodeV3(sSlug, sNode);

        this.$dataEngine.forceStoryNav({
          slug: sSlug,
          node: sNode,
        });

        this.EventBus.$emit('track:event', {
          event: 'channel-deep-stx',
          props: { mode: `${this.getTitle}: ${story.name}` },
          detail: { detail_char: `${this.getTitle}: ${story.name}` },
        });

        this.EventBus.$emit('layer:new', {
          'component': 'story',
          'opts': {
            context: 'stack',
            slug: sSlug,
            node: sNode,
          },
          'onClose': () => {
            // console.log(`\x1b[36m[LAYER] -- CLOSE CALLBACK!`);
            this.$dataEngine.forceStoryNav({});
          }
        });
      },

      animateDashboard() {
        const sequence = []
        this.summaryItems.forEach((item) => {
          sequence.push({ type: 'stat', unlocked: this.isUnlocked(item.slug) , ...item });
        });

        const promises = sequence.map((step) => {
          return new Promise((resolve) => {
            setTimeout(() => {
              this.progress[step.slug] = this.summaryItems[step.slug]?.px;
              this.achievement[step.slug] = this.dialDiff[step.slug].cx;
              this.EventBus.$emit("device:haptic", 'light');
              resolve();
            }, this.timing.steps);
          });
        });

        Promise.all(promises).then(() => {
          setTimeout(() => {
            this.$refs.lottie?.play()
          }, this.summarySequence?.length * this.timing.steps)
        });
      },

      getMood(mood) {
        if (mood < -0.25) {
          return {
            code: 'negative',
            name: 'Negative'
          }
        } else if (mood > 0.25) {
          return {
            code: 'positive',
            name: 'Positive'
          }
        }

        return {
          code: 'neutral',
          name: 'Neutral'
        }
      },

      close() {
        this.EventBus.$emit('track:event', {
          event: 'channel-close-x',
          props: { mode: this.getTitle },
          detail: { detail_char: this.getTitle },
        });
        this.$emit('preview:close')
      },

      sound() {
        const video = this.$refs.previewVideo;
        video.muted = !video.muted;
        this.isMuted = video.muted;
        this.$userEngine.setPref('layout.media.mute', video.muted);
        this.EventBus.$emit('track:event', {
          event: 'channel-preview-sound',
          props: { mode: video.muted ? 'Mute' : 'Unmute' },
          detail: { detail_char: video.muted ? 'Mute' : 'Unmute' },
        });
      },

      unlock() {
        this.EventBus.$emit('track:event', {
          event: 'channel-unlock',
          props: { mode: 'Tapped Locked: Go Pro' },
          detail: { detail_char: 'Tapped Locked: Go Pro' },
        });
        this.EventBus.$emit('layer:new', {
          component: 'unlock',
          opts: {
            name: this.getTitle,
            slug: this.stackSlug,
          }
        })
      },

      routeTo(type) {
        switch (type) {
          case 'invite':
            this.EventBus.$emit('track:event', {
              event: 'tap-unlx-invite',
              props: { mode: this.getTitle },
              detail: { detail_char: this.getTitle },
            });
            this.$router.push(`/~${this.getAccount.screen_name}/invite`);
            return;
          case 'read':
            this.EventBus.$emit('track:event', {
              event: 'tap-unlx-detox',
              props: { mode: this.getTitle },
              detail: { detail_char: this.getTitle },
            });
            this.$router.push(`/`);
            return;
          default: return;
        }
      },

      goPro() {
        this.EventBus.$emit('track:event', {
          event: 'tap-unlx-pro',
          props: { mode: this.getTitle },
          detail: { detail_char: this.getTitle },
        });
        this.EventBus.$emit("didSelectSubscribe", {
          didSelect: 'true' 
        });
      },

      videoImage() {
        if (this.oRandImage) {
          return this.oRandImage;
        }

        let images = [];
        this.stack?.stories?.forEach(story => {
          story?.articles?.forEach(article => {
            images.push({
              story: story.slug,
              article: article.slug,
              image: article.image,
              photo: article.photo,
              publisher: article.publisher,
              caption: article.name,
            });
          });
        });

        // ONLY choose once!
        this.oRandImage = images.filter(a => a.photo).sort( () => .5 - Math.random() ).pop();
        return this.oRandImage;
      },

      watch() {
        this.EventBus.$emit('track:event', {
          event: 'channel-watch',
          props: { mode: this.getTitle },
          detail: { detail_char: this.getTitle },
        });

         if (this.$refs.previewVideo) {
          const video = this.$refs.previewVideo;
          video.muted = true;
          this.isMuted = true;
          video.pause();
        }

        const size = this.isDesktop ? 'long-wide' : 'long-tall';
                
        let video = this.stack?.shelf?.vfx[size];
        if (video) {
          this.EventBus.$emit('layer:new', {
            component: 'media',
            opts: {
              src: video,
              meta: this.stack.meta,
            },
          });
        }

        // if (this.isAlpha) {
        //   if (this.$refs.previewVideo) {
        //     const video = this.$refs.previewVideo;
        //     video.muted = true;
        //     this.isMuted = true;
        //     video.pause();
        //   }

        //   const size = this.isDesktop ? 'long-wide' : 'long-tall';
                  
        //   let video = this.stack?.shelf?.vfx[size];
        //   if (video) {
        //     this.EventBus.$emit('layer:new', {
        //       component: 'media',
        //       opts: {
        //         src: video,
        //         meta: this.stack.meta,
        //       },
        //     });
        // }
        // } else {
        //   this.EventBus.$emit('layer:new', {
        //     component: 'message',
        //     opts: {
        //       heading: `Full length video is on it's way`,
        //       message: `We're still busy building full length videos, but we're almost there!`,
        //       action: {
        //         type: 'close',
        //         label: 'Ok!'
        //       }
        //     },
        //   });
        // }
      },

      resumeVideo() {
        if (this.$refs.previewVideo) {
          this.$refs.previewVideo.play();
        }
      },

      read() {
        this.EventBus.$emit('track:event', {
          event: 'channel-read',
          props: { mode: this.getTitle },
          detail: { detail_char: this.getTitle },
        });
        this.EventBus.$emit('swiper:next')
      },

      like() {
        this.EventBus.$emit('track:event', {
          event: 'channel-like',
          props: { mode: this.getTitle },
          detail: { detail_char: this.getTitle },
        });
        this.EventBus.$emit('layer:new', {
          component: 'message',
          opts: {
            heading: `Likes are on their way!`,
            message: `We're still building this feature, but we're happy you like ${this.stack.meta?.name}!`,
            action: {
              type: 'close',
              label: 'Ok!'
            }
          },
        });
      },

      share() {
        this.EventBus.$emit('track:event', {
          event: 'channel-share',
          props: { mode: this.getTitle },
          detail: { detail_char: this.getTitle },
        });
        if (this.hasApp) {
          this.EventBus.$emit("appCallback", {
            type: 'socialCallback',
            data: {
              social: 'url',
              link: `https://nourished.news/n/${this.stack.meta.slug}`,
            }
          });
          return;
        } else {
          this.EventBus.$emit('layer:new', {
            component: 'message',
            opts: {
              heading: `Spread the love`,
              message: `Know someone who'd enjoy ${this.stack.meta?.name}? Help them discover a better news.`,
              share: {
                url: `https://nourished.news/n/${this.stack.meta.slug}`,
                message: this.stack.meta?.edition?.synopsis,
              }
            },
          });
        }
      }
    },

    watch: {
      '$route.params.stack': {
        handler(slug) {
          if (slug === this.slide.slug) {
            if (this.$refs.previewVideo) {
              this.$refs.previewVideo.play();
            }
          } else {
            if (this.$refs.previewVideo) {
              this.$refs.previewVideo.pause();
            }
          }
        },
        immediate: true,
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .stack-modal {
    padding-bottom: 4rem;
    background: rgba(0,0,0,1);
    color: white;

    .desktop & {
      background: $neutral-200;
    }

    &.expanded {
      margin-top: 0;
      border-radius: 0;
    }

    .trailer {
      position: relative;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      overflow: hidden;

      // stop the flicker hack... 
      height: 219px;

      .desktop & {
        height: 500px;

        &::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(to bottom, rgba($neutral-200,0) 0%, rgba($neutral-200,1) 100%);
          pointer-events: none;
        }
      }

      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        background: rgb(0,0,0);

        .desktop & {
          background: $neutral-200;
        }
      }

      .control-btn {
        position: absolute;
        z-index: 10;
        top: 1rem;
        right: 3.5rem;
        // bottom: 0.75rem;
        // right: 0.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        align-self: flex-end;
        width: 44px;
        height: 44px;
        background: none;
        border-radius: 500px;
        padding: 0 1px 1px 0;

        svg {
          filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.6))
                  drop-shadow(0 3px 6px rgba(0, 0, 0, 0.3));
        }

        // .desktop & {
        //   top: 1rem;
        //   bottom: unset;
        //   right: 4.5rem;
        // }
      }
    }

    .stack-content {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      padding: 4rem 1.5rem 1.5rem 1.5rem;
      position: relative;
      z-index: 10;

      &.has-trailer {
        padding: 1.5rem 1.5rem;
      }

      .desktop & {
        display: grid;
        grid-template-columns: 1fr 1fr;
        padding: 2rem 0 2rem 0;

        &.has-trailer {
          padding: 0 0 2rem 0;
          margin-top: -3rem;
        }
      }

      .stack-column {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        .desktop & {
          padding: 1.5rem 3rem;
        }
      }

      .stack-lead {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;

        .desktop & {
          flex-direction: column;
          gap: 1rem;
          align-items: flex-start;
        }

        h1 {
          font-size: 2rem;

          .desktop & {
            font-size: 2rem;
          }
        }

        .read-status {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-weight: bold;
          color: $neutral-400;

          .desktop & {
            flex-direction: row-reverse;
          }

          .read {
            color: $green-tone-3;
          }

          .tracker {
            margin-top: 2px;
          }
        }
      }

      p {
        font-size: 1.1rem;
        margin-bottom: 0;
      }

      .meta {
        display: flex;
        gap: 0.75rem;

        .meta-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.9rem;
          font-weight: bold;
          color: $neutral-400;

          svg path {
            fill: $neutral-400;
          }
        }
      }

      .actions {
        display: flex;
        gap: 1rem;

        button {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          margin-top: 0.5rem;
          height: 55px;
          border-radius: 10px;
          font-size: 1rem;
          padding-top: 0.8rem;
          width: 100%;
          background: $neutral-600;
          color: black;

          svg path {
            fill: black;
          }

          &.watch {
            background: $yellow-tone-3;
            color: black;

            svg path {
              fill: black;
            }
          }

          &.locked {
            background: $red-tone-4;
            color: $red-tone-1;
            cursor: default;

            svg path {
              fill: $red-tone-1;
            }

            &:hover {
              transform: unset;
            }
          }

          &.unlock {
            background: url(@assets/images/n25xo/banner-bg-light.jpg);
            background-size: cover;
            color: rgba(0,0,0);

            svg path {
              fill: rgb(0,0,0);
            }
          }
        }
      }

      $bg-opacity: 0.07;

      .streaks {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        border: 1px solid rgba($neutral-400, 0.15);
        border-radius: 10px;
        margin: 1rem 0 0 0;
        width: 100%;
        overflow: hidden;

        .streak-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;
          font-weight: bold;
          padding: 2rem 0;
          text-align: center;
          flex: 1;
          overflow: hidden;
          color: $neutral-400;
          background: rgba($neutral-400, 0.05);

          svg {
            height: 1.5rem;
            width: 1.5rem;
            fill: $neutral-400;
          }

          &:not(:last-child) {
            border-right: 1px solid rgba($neutral-400, 0.15);
          }

          &.streak {
            color: $orange-tone-3;
            background: rgba($orange-tone-3, $bg-opacity);

            svg path {
              fill: $orange-tone-3;
            }

            &.achieved {
              color: $green-tone-3;
              background: rgba($green-tone-3, $bg-opacity);

              svg path {
                fill: $green-tone-3;
              }
            }
          }

          &.xp {
            color: $purple-tone-2;
            background: rgba($purple-tone-3, $bg-opacity);

            svg {
              fill: $purple-tone-2;
            }
          }
        }
      }

      .dashboard-group {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0;
        width: 100%;
      }

      .dashboard {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        border: 1px solid rgba($neutral-400, 0.15);
        border-radius: 10px;
        margin: 1rem 0 0 0;
        width: 100%;
        overflow: hidden;

        .dashboard-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;
          font-weight: bold;
          padding: 2rem 0;
          text-align: center;
          flex: 1;
          overflow: hidden;
          color: $neutral-400;
          background: rgba($neutral-400, 0.05);

          svg {
            fill: $neutral-400;
          }

          &:not(:last-child) {
            border-right: 1px solid rgba($neutral-400, 0.15);
          }

          &.countries {
            color: $locales-tone;
            background: rgba($locales-tone, $bg-opacity);

            svg {
              fill: $locales-tone;
            }
          }

          &.topics {
            color: $topics-tone;
            background: rgba($topics-tone, $bg-opacity);

            svg {
              fill: $topics-tone;
            }
          }

          &.time {
            color: $time-tone;
            background: rgba($time-tone, $bg-opacity);

            svg {
              fill: $time-tone;
            }
          }
        }
      }

      .publishers {
        color: $neutral-400;
        font-size: 0.9rem;
        text-wrap: balance;

        .desktop & {
          text-align: right;
        }
      }

      .other-actions {
        display: flex;
        justify-content: space-around;
        margin-top: 1rem;

        .desktop & {
          justify-content: flex-end;
          gap: 3.5rem;
        }

        .action-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;
          color: $neutral-400;
          font-weight: bold;
          transition: all 0.2s ease-in-out;
          cursor: pointer;

          svg path {
            fill: $neutral-400;
            transition: all 0.2s ease-in-out;
          }

          &:hover {
            color: $neutral-600;

            svg path {
              fill: $neutral-600;
            }
          }
        }
      }

      .deep-dive {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 2rem;

        .desktop & {
          grid-column: 1 / span 2;
        }
  
        h2 {
          font-size: 1.1rem;
          padding-bottom: 5px;
          border-bottom: 2px solid $yellow-tone-3;

          .desktop & {
            margin-left: 3rem;
            margin-right: 3rem;
          }
        }

        p {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin-top: 1rem;
          color: $red-tone-2;
          font-weight: bold;
          font-size: 0.9rem;

          svg path {
            fill: $red-tone-2;
          }

          .desktop & {
            margin-left: 3rem;
            margin-right: 3rem;
          }
        }

        .stories {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-top: 1.5rem;

          .desktop & {
            flex-direction: row;
            overflow-y: scroll;
            -ms-overflow-style: none;
            overflow: -moz-scrollbars-none;
            &::-webkit-scrollbar {
              display: none;
            }
            width: 100%;
            padding: 0 3rem;
            gap: 1.5rem;
            margin-top: 2rem;
          }

          &.locked {
            opacity: 0.25;
            filter: blur(5px);
            cursor: default;
            pointer-events: none;
          }

          .story {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 100%;
            background: rgba($neutral-400, 0.1);
            border-radius: 10px;
            color: $neutral-600;
            cursor: pointer;
            transition: all 0.2s ease-in-out;

            .desktop & {
              min-width: 20rem;
              max-width: 20rem;
            }

            &:hover {
              background: rgba($neutral-400, 0.15);
            }

            .story-image {
              width: 100%;
            }

            .inner-image {
              width: 100%;
              height: 10rem;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-top-left-radius: 6px;
                border-top-right-radius: 6px;
              }
            }

            .item-mood {
              display: flex;
              align-items: center;
              gap: 0.3rem;
              background: none;
              padding-bottom: 2px;

              .item-mood-marker {
                width: 7px;
                height: 7px;
                border-radius: 500px;
              }

              span {
                display: inline-block;
                font-size: 0.8rem;
                color: $neutral-400;
                padding-bottom: 1px;
              }

              &.positive {
                color: $green-tone-3;
                .item-mood-marker {
                  background: $green-tone-3;
                }
              }

              &.neutral {
                color: $blue-tone-3;
                .item-mood-marker {
                  background: $blue-tone-3;
                }
              }

              &.negative {
                color: $red-tone-3;
                .item-mood-marker {
                  background: $red-tone-3;
                }
              }
            }

            .story-content {
              display: flex;
              flex-direction: column;
              gap: 0.4rem;
              flex: 1;
              padding: 1.5rem 1rem 1rem 1rem;

              .story-name {
                font-size: 1.1rem;
                line-height: 140%;
              }

              .story-meta-wrapper {
                display: flex;
                align-items: center;
                margin-bottom: 0.25rem;

                .story-meta {
                  display: flex;
                  align-items: center;
                  font-size: 0.8rem;
                  color: $neutral-400;

                  svg {
                    margin-top: 1px;
                    margin-right: 0.2rem;
                    
                    path {
                      fill: $neutral-400;
                    }
                  }

                  &:not(:last-child) {
                    &::after{
                      content: '|';
                      margin: 0 0.4rem;
                      color: $neutral-400;
                    }
                  }
                }
              }

              .story-stack {
                font-size: 0.8rem;
                color: $neutral-400;
                line-height: 140%;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }
            }

            .meta {
              display: flex;
              flex-wrap: wrap;
              font-size: 0.8rem;
              gap: 0.5rem;
              padding: 1rem 1rem 1.5rem 1rem;

              li {
                color: $neutral-400;
                border-bottom: 1px solid $neutral-400;
                padding-bottom: 2px;
                transition: all 0.2s ease-in-out;

                &:hover {
                  color: $neutral-600;
                  border-bottom: 1px solid $neutral-600;
                }
              }
            }
          }
        }
      }

      .unlock-actions {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        text-align: center;
        margin: 0rem 0 2rem 0;

        h2 {
          font-size: 22px;
        }

        p {
          text-wrap: balance; 
        }

        .unlock-options {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-top: 1rem;

          .unlock-option {
            display: flex;
            align-items: center;
            gap: 1.5rem;
            padding: 1rem 1.5rem;
            border-radius: 15px;
            border: 1px solid rgba($yellow-tone-3, 0.5);
            background: rgba($yellow-tone-3, 0.05);
            cursor: pointer;
            transition: all 0.2s ease-in-out;
            
            &:hover {
              transform: scale(1.05);
            }

            svg path {
              fill: $yellow-tone-3;
            }

            &.pro {
              border: 1px solid rgba($green-tone-3, 0.5);
              background: rgba($green-tone-3, 0.05);

              svg path {
                fill: $green-tone-3;
              }
            }

            .unlock-content {
              display: flex;
              flex-direction: column;
              text-align: left;
              flex: 1;

              h3 {
                font-size: 1rem;
                margin-bottom: 0.25rem;
              }

              p {
                line-height: 140%;
              }
            }
          }
        }
      }
    }
  }
</style>